import { render } from "./TradePassportPreviewModal.vue?vue&type=template&id=90624680&ts=true"
import script from "./TradePassportPreviewModal.vue?vue&type=script&lang=ts"
export * from "./TradePassportPreviewModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__